// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";

import IconMinus from "../../icons/minus.svg";
import IconPlus  from "../../icons/plus.svg";

import Button from "../Button";

type Props = {
  class? : string,
  max?   : number,
  min?   : number,
  qty    : number,
  setQty : Function,
};

export default class QtyPicker extends PureComponent {
  props: Props;

  static defaultProps = {
    max : Number.MAX_VALUE,
    min : 1,
  };

  setQty = qty => this.props.setQty(
    Math.max(Math.min(qty, this.props.max), this.props.min)
  );

  qtyIncrease = () => this.setQty(this.props.qty + 1);
  qtyDecrease = () => this.setQty(this.props.qty - 1);

  handleFocus  = (event: Event) => this.input.select();
  handleChange = (event: Event) => this.setQty(event.target.value|0);

  handleKeydown = (event: Event) => {
    switch (event.which) {
      case 38: event.preventDefault(); this.qtyIncrease(); break;
      case 40: event.preventDefault(); this.qtyDecrease(); break;
    }
  }

  render({ disabled, max, min, qty, setQty }: Props, state: any, { t }: Context) {
    return (
      <div
          class={classNames(
            this.props["class"],
            styles.block
          )}>

        <Button
            onClick={this.qtyDecrease}
            disabled={(qty <= min) || disabled}
            class={classNames(
              styles.button,
              styles.field
            )}>

          <IconMinus class={styles.icon} />
        </Button>

        <div class={styles.value}>
          <input
              value={qty || min}
              onFocus={this.handleFocus}
              onChange={this.handleChange}
              onKeydown={this.handleKeydown}
              ref={elem => this.input = elem}
              pattern="\d*"
              inputmode="numeric"
              class={classNames(
                styles.input,
                {[styles.disabled]: disabled}
              )}
          />

          <label
              class={styles.label}
              onClick={this.handleFocus}>

            {t("PRODUCT.PCS")}
          </label>
        </div>

        <Button
            onClick={this.qtyIncrease}
            disabled={(qty >= max) || disabled}
            title={qty >= max ? t("PRODUCT.MAX_QTY") : null}
            class={classNames(
              styles.button,
              styles.field
            )}>

          <IconPlus class={styles.icon} />
        </Button>
      </div>
    );
  }
}
